import type { OAuthMessage } from "@/types/oauth.types";
import { useEffect } from "react";

export default function StravaPopupClose() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const success = params.get("success") === "1";
    const provider = params.get("provider") || "strava";
    const athleteId = params.get("athleteId") ?? undefined;
    const error = params.get("error");
    const reason = params.get("reason") ?? undefined; // e.g. "already_linked"

    const message: OAuthMessage = success
      ? { type: "oauth-success", provider, athleteId }
      : { type: "oauth-error", provider, error, reason, athleteId };

    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(message, window.location.origin);
    }

    window.close();
  }, []);

  return (
    <div style={{ fontFamily: "system-ui", padding: 24 }}>
      <p>Finishing… you can close this window.</p>
    </div>
  );
}
